// A shift run (data-model.md "shifts" [internal]; shift-engine §2).
//
// The roster is Nightcrew-owned, never a customer setting (D37). A shift is scheduled,
// event-triggered (an on-call wake), or threshold-triggered (enough intake accumulated).
// Tenant-scoped by `accountId`; the customer does not configure it.
import { z } from "zod";
import { AccountId, AppId, ShiftId } from "../ids.js";
import { Timestamp } from "./common.js";
import { ShiftKind, ShiftStatus, ShiftTrigger } from "./enums.js";
export const Shift = z.object({
    id: ShiftId,
    accountId: AccountId,
    appId: AppId,
    kind: ShiftKind,
    trigger: ShiftTrigger,
    /** When the shift is due; null for an event/threshold trigger that fires out of band. */
    scheduledFor: Timestamp.nullable(),
    startedAt: Timestamp.nullable(),
    endedAt: Timestamp.nullable(),
    status: ShiftStatus,
});
//# sourceMappingURL=shift.js.map